/**
 * 이메일 클라 창구 — 「보내 달라」만 한다. 수신자·본문은 서버(`server/email/*`)가 정한다.
 */

import { fetchIdToken } from 'src/lib/firebase/auth-kit';

/**
 * 가입 환영 메일 — 로그인한 본인에게. 토큰이 없으면(로그아웃 등) 조용히 건너뛴다.
 * @returns `{ success }` — 실패는 던지지 않고 `success: false` 로 접는다(가입 흐름을 막지 않는다)
 */
export async function sendWelcomeEmail(_email?: string): Promise<{ success: boolean; error?: string }> {
  const token = await fetchIdToken();
  if (!token) return { success: false, error: 'not signed in' };
  try {
    const res = await fetch('/api/email/welcome', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return { success: false, error: `HTTP ${res.status}` };
    return { success: true };
  } catch (error) {
    return { success: false, error: (error as { message?: string })?.message ?? String(error) };
  }
}
